import { api } from './index';

// 미리 정의된 타임아웃 설정
export const TIMEOUT_PRESETS = {
  SHORT: 5000,    // 5초 - 빠른 조회
  NORMAL: 10000,  // 10초 - 일반적인 요청
  LONG: 30000,    // 30초 - 파일 업로드, 복잡한 처리
  VERY_LONG: 60000, // 60초 - 대용량 데이터 처리
} as const;

// 타임아웃별 API 요청 헬퍼 함수들
export const apiWithTimeout = {
  // 빠른 요청 (5초)
  quick: {
    get: (url: string, config = {}) => api.get(url, { ...config, timeout: TIMEOUT_PRESETS.SHORT }),
    post: (url: string, data?: any, config = {}) => api.post(url, data, { ...config, timeout: TIMEOUT_PRESETS.SHORT }),
    put: (url: string, data?: any, config = {}) => api.put(url, data, { ...config, timeout: TIMEOUT_PRESETS.SHORT }),
    delete: (url: string, config = {}) => api.delete(url, { ...config, timeout: TIMEOUT_PRESETS.SHORT }),
    patch: (url: string, data?: any, config = {}) => api.patch(url, data, { ...config, timeout: TIMEOUT_PRESETS.SHORT }),
  },

  // 일반 요청 (10초)
  normal: {
    get: (url: string, config = {}) => api.get(url, { ...config, timeout: TIMEOUT_PRESETS.NORMAL }),
    post: (url: string, data?: any, config = {}) => api.post(url, data, { ...config, timeout: TIMEOUT_PRESETS.NORMAL }),
    put: (url: string, data?: any, config = {}) => api.put(url, data, { ...config, timeout: TIMEOUT_PRESETS.NORMAL }),
    delete: (url: string, config = {}) => api.delete(url, { ...config, timeout: TIMEOUT_PRESETS.NORMAL }),
    patch: (url: string, data?: any, config = {}) => api.patch(url, data, { ...config, timeout: TIMEOUT_PRESETS.NORMAL }),
  },

  // 긴 요청 (30초)
  long: {
    get: (url: string, config = {}) => api.get(url, { ...config, timeout: TIMEOUT_PRESETS.LONG }),
    post: (url: string, data?: any, config = {}) => api.post(url, data, { ...config, timeout: TIMEOUT_PRESETS.LONG }),
    put: (url: string, data?: any, config = {}) => api.put(url, data, { ...config, timeout: TIMEOUT_PRESETS.LONG }),
    delete: (url: string, config = {}) => api.delete(url, { ...config, timeout: TIMEOUT_PRESETS.LONG }),
    patch: (url: string, data?: any, config = {}) => api.patch(url, data, { ...config, timeout: TIMEOUT_PRESETS.LONG }),
  },

  // 매우 긴 요청 (60초)
  veryLong: {
    get: (url: string, config = {}) => api.get(url, { ...config, timeout: TIMEOUT_PRESETS.VERY_LONG }),
    post: (url: string, data?: any, config = {}) => api.post(url, data, { ...config, timeout: TIMEOUT_PRESETS.VERY_LONG }),
    put: (url: string, data?: any, config = {}) => api.put(url, data, { ...config, timeout: TIMEOUT_PRESETS.VERY_LONG }),
    delete: (url: string, config = {}) => api.delete(url, { ...config, timeout: TIMEOUT_PRESETS.VERY_LONG }),
    patch: (url: string, data?: any, config = {}) => api.patch(url, data, { ...config, timeout: TIMEOUT_PRESETS.VERY_LONG }),
  },
};

// 사용 예시:
// import { apiWithTimeout, TIMEOUT_PRESETS } from './api/timeout';
// 
// // 미리 정의된 타임아웃 사용
// const items = await apiWithTimeout.quick.get('/items/');           // 5초
// const result = await apiWithTimeout.normal.post('/items/', data);  // 10초
// const upload = await apiWithTimeout.long.post('/upload/', file);   // 30초
// const report = await apiWithTimeout.veryLong.get('/reports/');     // 60초
// 
// // 커스텀 타임아웃 사용
// const custom = await api.get('/custom/', { timeout: 15000 });      // 15초

export default apiWithTimeout;
